import React, { FC } from 'react'
import styles from 'styles/components/list.module.scss'
import classNames from 'classnames'
import { PointCardOfferType as BasePointCardOfferType } from 'types/pointCard/pointCardOffer'
import { FirebaseDocRefType } from 'firebase/index'
import PointCardOfferListItem from './PointCardOfferListItem'

type PointCardOfferType = BasePointCardOfferType & { ref: FirebaseDocRefType }

type Props = {
  pointCardOffers: PointCardOfferType[]
}

const PointCardOfferList: FC<Props> = (props) => {
  const { pointCardOffers } = props

  return (
    <ul className={classNames(styles.pointCardOffer)}>
      {pointCardOffers.map((pointCardOffer) => (
        <PointCardOfferListItem pointCardOffer={pointCardOffer} key={pointCardOffer.ref.id} />
      ))}
    </ul>
  )
}

export default PointCardOfferList
